module.exports = __webpack_public_path__ + "img/greeting_cards.06007357.jpg";